/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_All_Team_Members_TextInputs */

const en_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This guide is accessible to all team members.`)
};

const fr_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce guide est accessible à tous les membres de l’équipe.`)
};

const de_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Leitfaden ist für alle Teammitglieder zugänglich.`)
};

const it_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa guida è accessibile a tutti i membri del team.`)
};

const ru_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данное руководство доступно всем членам команды.`)
};

const es_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta guía es accesible para todos los miembros del equipo.`)
};

const zh_cn2_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有团队成员均可查阅本指南。`)
};

const ja_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このガイドはチームメンバー全員がアクセスできます。`)
};

const hi_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह मार्गदर्शिका टीम के सभी सदस्यों के लिए उपलब्ध है।`)
};

const pt_pt2_knp_guide_all_team_members_text = /** @type {(inputs: Knp_Guide_All_Team_Members_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este guia está disponível para todos os membros da equipe.`)
};

/**
* | output |
* | --- |
* | "This guide is accessible to all team members." |
*
* @param {Knp_Guide_All_Team_Members_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_all_team_members_text = /** @type {((inputs?: Knp_Guide_All_Team_Members_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_All_Team_Members_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_all_team_members_text(inputs)
	if (locale === "de") return de_knp_guide_all_team_members_text(inputs)
	if (locale === "it") return it_knp_guide_all_team_members_text(inputs)
	if (locale === "ru") return ru_knp_guide_all_team_members_text(inputs)
	if (locale === "es") return es_knp_guide_all_team_members_text(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_all_team_members_text(inputs)
	if (locale === "ja") return ja_knp_guide_all_team_members_text(inputs)
	if (locale === "hi") return hi_knp_guide_all_team_members_text(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_all_team_members_text(inputs)
	return en_knp_guide_all_team_members_text(inputs)
});